import { render, staticRenderFns } from "./app-todo-list.vue?vue&type=template&id=59d9de2f&scoped=true&"
import script from "./app-todo-list.vue?vue&type=script&lang=ts&"
export * from "./app-todo-list.vue?vue&type=script&lang=ts&"
import style0 from "./app-todo-list.vue?vue&type=style&index=0&id=59d9de2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9de2f",
  null
  
)

export default component.exports